import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWithdrawalSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.333} fill='#FF4081' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='m15.323 12.875 1.92-1.92 1.92 1.92M17.243 18.635v-7.628M11.333 17c0 3.315 2.25 6 6 6s6-2.685 6-6'
    />
  </svg>
);
export default SvgWithdrawalSmall;
